webpackJsonp([129700431718080,251145715579556,42194186054388],{

/***/ 1277:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _CtaDefault = __webpack_require__(61);
	
	var _CtaDefault2 = _interopRequireDefault(_CtaDefault);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Whitespace = __webpack_require__(35);
	
	var _Whitespace2 = _interopRequireDefault(_Whitespace);
	
	var _MediaFeature = __webpack_require__(68);
	
	var _MediaFeature2 = _interopRequireDefault(_MediaFeature);
	
	var _Video = __webpack_require__(465);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	var _assets = __webpack_require__(82);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _grid = __webpack_require__(5);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _ExperimentBlock = __webpack_require__(233);
	
	var _ExperimentBlock2 = _interopRequireDefault(_ExperimentBlock);
	
	var _MobileBlock = __webpack_require__(234);
	
	var _MobileBlock2 = _interopRequireDefault(_MobileBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGE_COLOR = 'purple';
	
	var FeatureWireframing = function (_Component) {
	  _inherits(FeatureWireframing, _Component);
	
	  function FeatureWireframing(props) {
	    _classCallCheck(this, FeatureWireframing);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      videoOpen: false
	    };
	    return _this;
	  }
	
	  FeatureWireframing.prototype.render = function render() {
	    var buttons = [{
	      text: 'Sign up free',
	      link: '/signup/',
	      styles: {
	        shape: 'rounded',
	        minWidth: 160,
	        size: 'large'
	      }
	    }, {
	      text: 'Explore Plans',
	      link: '/pricing/',
	      styles: {
	        shape: 'rounded',
	        size: 'large',
	        minWidth: 160,
	        kind: 'ghost'
	      }
	    }];
	
	    var childButton = _react2.default.createElement(
	      _button2.default,
	      { size: 'large', shape: 'rounded', hover: 'green', kind: 'ghost' },
	      'Watch video'
	    );
	
	    var ctaBlock = _react2.default.createElement(
	      _grid.InlineGrid,
	      { startAfterS: true, size: 's', sizeS: 's' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/signup/?next=/onboarding/wireframing/' },
	        _react2.default.createElement(
	          _button2.default,
	          { size: 'large', shape: 'rounded', hover: 'blue' },
	          'Start wireframing for free'
	        )
	      ),
	      _react2.default.createElement(_Video2.default, { id: 'zztrodskog', childButton: childButton })
	    );
	
	    return _react2.default.createElement(
	      _Page2.default,
	      {
	        title: 'Wireframe - Free Rapid wireframe tool for iOS, Android & Desktop',
	        meta: [{
	          name: 'description',
	          content: 'Wireframe apps, websites and more with the thousands of assets, templates and assets from our wireframing tool, directly in your browser. Free forever!'
	        }, {
	          name: 'keywords',
	          content: 'wireframe, wireframe tools, wireframing, wireframe app, mockup tool, wireframe software'
	        }],
	        header: { isLight: false },
	        footer: true
	      },
	      _react2.default.createElement(
	        _pageWrap2.default,
	        { size: 'l' },
	        _react2.default.createElement(_Whitespace2.default, { size: 's', sizeS: 'l', sizeM: 'xl' }),
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 'xl', type: 'padding', position: 'top' },
	          _react2.default.createElement(
	            _align2.default,
	            { type: 'center' },
	            _react2.default.createElement(
	              _maxWidth2.default,
	              { value: 820 },
	              _react2.default.createElement(
	                _heading2.default,
	                { tag: 'h1', weight: 'semibold', size: 'mega' },
	                'A wireframing tool that gets you to the best idea, fast'
	              )
	            ),
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 's', type: 'padding', position: 'topBottom' },
	              _react2.default.createElement(
	                _maxWidth2.default,
	                { value: 720 },
	                _react2.default.createElement(
	                  _paragraph2.default,
	                  { size: 'xxxl', color: 'slate' },
	                  'Access hundreds of wireframe assets for every device. Simple templates, designed to help you implement ideas quickly.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 's', type: 'padding', position: 'top' },
	              _react2.default.createElement(
	                _spacing2.default,
	                { size: 'l', type: 'padding', position: 'bottom' },
	                ctaBlock
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_MediaFeature2.default, _extends({}, _assets2.default.canvas, {
	          backgroundColor: PAGE_COLOR,
	          patternLeft: '34.5%',
	          patternTop: '30%'
	        })),
	        _react2.default.createElement(_Whitespace2.default, { size: 'l' }),
	        _react2.default.createElement(_MobileBlock2.default, { color: PAGE_COLOR }),
	        _react2.default.createElement(_ExperimentBlock2.default, null),
	        _react2.default.createElement(_CtaDefault2.default, {
	          maxWidth: 480,
	          title: 'Join over 2 million people wireframing with Marvel. Get started for free.',
	          buttons: buttons
	        })
	      )
	    );
	  };
	
	  return FeatureWireframing;
	}(_react.Component);
	
	exports.default = FeatureWireframing;
	module.exports = exports['default'];

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = FeatureWireframing;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _MediaThreeColImages = __webpack_require__(208);
	
	var _MediaThreeColImages2 = _interopRequireDefault(_MediaThreeColImages);
	
	var _assets = __webpack_require__(82);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FeatureWireframing() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: '0', sizeM: 'xl', type: 'padding', position: 'topBottom' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: 'xl', sizeM: '0', position: 'bottom' },
	      _react2.default.createElement(
	        _reactResponsive2.default,
	        { maxWidth: 769 },
	        _react2.default.createElement(_MediaThreeColImages2.default, {
	          radius: 'none',
	          background: 'none',
	          fallbackImage: _assets2.default.screensFallbackRetina,
	          images: _assets2.default.experimentBlock
	        })
	      ),
	      _react2.default.createElement(
	        _pageWrap2.default,
	        { size: 'l' },
	        _react2.default.createElement(_HeadingBlock2.default, {
	          justifyContent: 'center',
	          justifyM: 'start',
	          title: 'Drag and drop wireframe templates',
	          copy: _react2.default.createElement(
	            'span',
	            null,
	            'We\u2019ve designed hundreds of simple wireframe assets for every device, all stored in our intuitive wireframing tool.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'All the assets are included with Marvel, no add-ons necessary. We\'ve taken care of everything, so you can focus on generating ideas.'
	          ),
	          size: 'xs'
	        })
	      ),
	      _react2.default.createElement(
	        _reactResponsive2.default,
	        { minWidth: 770 },
	        _react2.default.createElement(_MediaThreeColImages2.default, {
	          radius: 'none',
	          background: 'shape',
	          fallbackImage: _assets2.default.experimentBlock[0],
	          images: _assets2.default.experimentBlock
	        })
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = MobileBlock;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _MediaMultipleImages = __webpack_require__(30);
	
	var _MediaMultipleImages2 = _interopRequireDefault(_MediaMultipleImages);
	
	var _ParallaxWrapper = __webpack_require__(28);
	
	var _ParallaxWrapper2 = _interopRequireDefault(_ParallaxWrapper);
	
	var _Pattern = __webpack_require__(31);
	
	var _Pattern2 = _interopRequireDefault(_Pattern);
	
	var _Shape = __webpack_require__(27);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _assets = __webpack_require__(82);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MobileBlock(_ref) {
	  var color = _ref.color;
	
	  return _react2.default.createElement(
	    _pageWrap2.default,
	    { size: 'l' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: '0', sizeM: 'xl', type: 'padding', position: 'topBottom' },
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 12 },
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 12, columnSpanM: 7, alignContent: 'center' },
	          _react2.default.createElement(
	            _MediaMultipleImages2.default,
	            {
	              fallbackImageAlt: _assets2.default.wireframeFallbackRetina.alt,
	              fallbackImageSrc: _assets2.default.wireframeFallbackRetina.src,
	              fallbackImageMaxWidth: _assets2.default.wireframeFallbackRetina.maxWidth
	            },
	            _react2.default.createElement(_Shape2.default, { type: 'square', color: color, width: 426, height: 375 }),
	            _react2.default.createElement(
	              _ParallaxWrapper2.default,
	              { speed: 1 },
	              _react2.default.createElement(_Pattern2.default, {
	                color: 'purple',
	                left: 'auto',
	                right: '22%',
	                top: '26%',
	                type: 'shortRectangle'
	              })
	            ),
	            _react2.default.createElement(
	              _ParallaxWrapper2.default,
	              { speed: 1 },
	              _react2.default.createElement(_Pattern2.default, {
	                bottom: '30%',
	                color: 'purple',
	                left: '22%',
	                top: 'auto',
	                type: 'shortRectangle'
	              })
	            ),
	            _react2.default.createElement(
	              _ParallaxWrapper2.default,
	              { speed: 0.8 },
	              _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.watchOne, {
	                left: '15%',
	                maxWidth: 159,
	                position: 'absolute',
	                top: '30%'
	              }))
	            ),
	            _react2.default.createElement(
	              _ParallaxWrapper2.default,
	              { speed: 1 },
	              _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.watchTwo, {
	                right: '13%',
	                maxWidth: 168,
	                position: 'absolute',
	                top: '43%'
	              }))
	            ),
	            _react2.default.createElement(
	              _ParallaxWrapper2.default,
	              { speed: 2 },
	              _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.wireframe, {
	                right: '29%',
	                maxWidth: 312,
	                position: 'absolute',
	                bottom: '10%'
	              }))
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 12, columnSpanM: 5, alignContent: 'center' },
	          _react2.default.createElement(_HeadingBlock2.default, {
	            justifyContent: 'center',
	            alignContent: 'center',
	            maxWidth: 420,
	            title: 'Wireframe for any device',
	            copy: _react2.default.createElement(
	              'span',
	              null,
	              'Go from idea to wireframe within minutes for any device, iPhone, iPad, Android and desktop.',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null),
	              'Perfect for the early stages of the design process when you\u2019re trying to form your concept into something tangible and translate it to your team, clients or stakeholders.'
	            )
	          })
	        )
	      )
	    )
	  );
	}
	
	MobileBlock.propTypes = {
	  color: _propTypes2.default.string.isRequired
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-features-wireframe-and-design-ux-index-js-1cf71b00b958b40cc481.js